import React, { useEffect, useState } from 'react';
import {
  Button,
  Select,
  Skeleton,
  TextArea,
  TextField,
  Title
} from '@gerdau/hefesto';
import { DateField } from '@gerdau/hefesto-mais-web/DateField';
import { DateType } from '@gerdau/hefesto-mais-web/DateField/DateField.types';
import { TSelectOptionProps } from '@gerdau/hefesto/Select/Select.types';
import { Button as ButtonAntd, Tooltip } from 'antd';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import FabricationContractsSelect from '../../../../components/FabricationContractsSelect';
import IsManagerFabricationContractInput from '../../../../components/IsManagerFabricationContractInput';
import { ERoutes } from '../../../../routes';
import { FabricationOrdersService } from '../../../../services/FabricationOrders';
import { ApplicationState } from '../../../../store';
import {
  loadCustomerContracts,
  updateConstructionRegistrationSettings
} from '../../../../store/ducks/contracts-and-constructions/actions';
import {
  ETowerOption,
  INITIAL_CONSTRUCTION_REGISTRATION
} from '../../../../store/ducks/contracts-and-constructions/types';
import {
  loadContractByContractNumberV2,
  loadContractDetails,
  loadContractDetailsV2,
  loadRequestNewOrder
} from '../../../../store/ducks/fabrication-contracts/actions';
import {
  EFabricationContractsStatus,
  IFabricationContract,
  ILastOrderDetails
} from '../../../../store/ducks/fabrication-contracts/types';
import { IFabricationOrder } from '../../../../store/ducks/fabrication-orders/types';
import {
  EFabricationOrderSteps,
  IConstructionIdentificationState,
  IFabricationPurchaseOrderState
} from '../../../../store/ducks/fabrication-purchase-order/types';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { ECustomerTypeView } from '../../../../store/ducks/user/types';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';
import { cepInputValidator } from '../../../../utils/cepInputValidator';
import {
  textEllipsis,
  uppercaseOnlyFirstLetter
} from '../../../../utils/formatStrings';
import { getFabricationPurchaseStateFromFabricationOrder } from '../../../../utils/purchaseHelpers';
import { EConstructionsRoutes } from '../../../ContractsAndConstructions/contractsAndConstructions.routes';
import { EFabricationRoutes } from '../fabrication.routes';
import { isAllFieldsValidInConstructionIdentification } from '../fabricationOrderFieldsValidations';
import { FabricationContainer, FabricationErrorBlock } from '../styles';
import ContractWithoutConstructions from './ContractWithoutConstructions';
import LoadingFabricationOrderModal from './LoadingFabricationOrderModal';
import {
  ButtonActionContainer,
  ButtonContainer,
  ConstructionContainer,
  ConstructionIdentificationContentBlock,
  ContructionIdentificationInputContainer,
  DeliveryNotesContainer,
  Message,
  OrderContainer,
  SearchContractButtonContainer
} from './styles';
import MessageChooseContract from '../../../../components/MessageChooseContract';
import LoadingModal from '../../../../components/LoadingModal';
import { updateFabricationPurchaseOrderSettings } from '../../../../store/ducks/fabrication-purchase-order/actions';
import { ChooseBetweenNewOrReviewOrderModal } from '../../../../components/ChooseBetweenNewOrReviewOrderModal';

interface IConstructionIdentificationProps {
  constructionIdentificationState: IConstructionIdentificationState;
  setConstructionIdentificationState(
    constructionIdentificationState: IConstructionIdentificationState
  ): void;
  onChangeContractNumber(): void;
  onInitFabricationRoute(fabricationOrderStep: EFabricationOrderSteps): void;
  goToFabricationRoute(route: EFabricationRoutes): void;
  onBuyAgain(fabricationPurchaseState: IFabricationPurchaseOrderState): void;
}

const ConstructionIdentification: React.FC<
  IConstructionIdentificationProps
> = ({
  constructionIdentificationState,
  setConstructionIdentificationState,
  goToFabricationRoute,
  onInitFabricationRoute,
  onChangeContractNumber,
  onBuyAgain
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const isOnline = useSelector(
    (appState: ApplicationState) => appState.connectivity.online
  );

  const contractsState = useSelector(
    (appState: ApplicationState) => appState.fabricationContracts
  );
  const userState = useSelector((appState: ApplicationState) => appState.user);

  const contractAndConstructionsContractsManager = useSelector(
    (state: ApplicationState) =>
      state.contractsAndConstructions.contractsManager
  );

  const newOrderContract = useSelector(
    (state: ApplicationState) =>
      state.fabricationContracts.requestNewOrderContract
  );

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    history.location.pathname,
    true
  );
  const getSelectedContract = (contractNumber?: string) => {
    return contractsState.contracts?.find(
      (contr) => !!contractNumber && contr.contractNumber === contractNumber
    );
  };

  const [isManagercontractNumber, setIsManagerContractNumber] = useState(
    constructionIdentificationState.contractNumber
  );

  const [selectedContract, setSelectedContract] = useState(
    getSelectedContract(constructionIdentificationState.contractNumber)
  );

  const [isOfflineTooltipOpen, setIsOfflineTooltipOpen] = useState(false);
  const [isOfflineTooltipOpen2, setIsOfflineTooltipOpen2] = useState(false);

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName,
        page: history.location.pathname,
        event: 'page_view'
      })
    );
  }, []);

  useEffect(() => {
    onInitFabricationRoute(EFabricationOrderSteps.CONSTRUCTION_IDENTIFICATION);

    if (selectedContract?.contractNumber) {
      dispatch(loadRequestNewOrder(selectedContract.contractNumber));
    }
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleUpdateStateField = (field: string, newValue: any) => {
    setConstructionIdentificationState({
      ...constructionIdentificationState,
      [field]: newValue
    });
  };

  const msgHelperText =
    'Campo para especificação da etapa de sua obra e/ou identificação interna do seu pedido. Essa informação será inserida no corpo da nota fiscal';

  const onNextStepClick = () => {
    goToFabricationRoute(EFabricationRoutes.DETAILING_PROJECT);
    dispatch(
      sendTagging({
        screenName: 'LG:Comprar:CorteEDobra:IdentificacaoObra',
        event: 'click',
        itemName: 'button:avancarParaDetalhamento',
        itemDescription:
          'comprar_corteEDobra_identificacaoObra_avancarParaDetalhamento',
        filterInfo: `#cttObra:${selectedContract?.contractNumber}`,
        contratoObra: selectedContract?.contractNumber
      })
    );
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onClickCancelButton = () => {
    dispatch(
      sendTagging({
        screenName: 'LG:Comprar:CorteEDobra:IdentificacaoObra',
        itemName: 'button:cancelar',
        event: 'click',
        filterInfo: `#cttObra:${selectedContract?.contractNumber}`,
        contratoObra: selectedContract?.contractNumber,
        itemDescription: `comprar_corteEDobra_identificacaoObra_cancelar`
      })
    );
    history.push(`${ERoutes.PURCHASE}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleChangeContractNumber = (selectedContractNumber: string) => {
    if (contractsState.contracts === undefined) {
      return;
    }

    const contract = getSelectedContract(
      selectedContractNumber
    ) as IFabricationContract;

    setConstructionIdentificationState({
      ...constructionIdentificationState,
      contractNumber: contract?.contractNumber,
      location: contract?.location,
      address: '',
      state: '',
      city: '',
      cep: '',
      towers: [],
      orderNumber: ''
    });

    onChangeContractNumber();
    !!contract.contractNumber &&
      dispatch(loadContractByContractNumberV2(contract.contractNumber));
    setSelectedContract(contract);

    if (contract?.contractNumber) {
      dispatch(loadRequestNewOrder(contract.contractNumber));
    }
  };

  const handleLoadContractByContractNumber = () => {
    if (!isManagercontractNumber) {
      return;
    }

    setConstructionIdentificationState({
      ...constructionIdentificationState,
      contractNumber: isManagercontractNumber,
      location: '',
      address: '',
      state: '',
      city: '',
      cep: '',
      towers: []
    });

    onChangeContractNumber();
    dispatch(loadContractByContractNumberV2(isManagercontractNumber));
  };

  const handleLoadContractDetails = (
    selectedContractNumber: string,
    customerShipTo?: string
  ) => {
    dispatch(loadContractDetails(selectedContractNumber, customerShipTo));
  };

  const handleLoadContractDetailsV2 = (selectedContractNumber: string) => {
    dispatch(loadContractDetailsV2(selectedContractNumber));
  };

  const initConstructionIdentificationAddress = () => {
    if (
      constructionIdentificationState.contractNumber &&
      contractsState.contracts
    ) {
      const contract = getSelectedContract(
        constructionIdentificationState.contractNumber
      );

      if (
        contract &&
        contract.shipTo &&
        contract.shipTo.address &&
        (!constructionIdentificationState.cep ||
          constructionIdentificationState.cep !== contract.shipTo.zipCode)
      ) {
        setConstructionIdentificationState({
          ...constructionIdentificationState,
          location: contract.location,
          address: contract.shipTo.address,
          state: contract.shipTo.state || '',
          city: contract.shipTo.city || '',
          cep: contract.shipTo.zipCode || ''
        });
      } else if (
        !userState.isManager &&
        contract &&
        contract.status === EFabricationContractsStatus.OPEN &&
        !contract.shipTo?.address &&
        !contract.loadingDetails &&
        !contract.errorDetails
      ) {
        handleLoadContractDetailsV2(
          constructionIdentificationState.contractNumber
        );
      }
      setSelectedContract(contract);
    }
  };

  useEffect(() => {
    initConstructionIdentificationAddress();
  });

  const canShowToNextStep = () => {
    return isAllFieldsValidInConstructionIdentification(
      constructionIdentificationState,
      contractsState
    );
  };

  const isAnewContractSelected = (): boolean => {
    return (
      !!selectedContract &&
      selectedContract.status === EFabricationContractsStatus.NEW_CONTRACT
    );
  };

  const hasErrorOnLoadSelectedContractDetails = (): boolean => {
    return !!selectedContract && !!selectedContract.errorDetails;
  };

  const cleanConstructionIdentificationState = () => {
    setSelectedContract(undefined);
    setConstructionIdentificationState({
      ...constructionIdentificationState,
      contractNumber: undefined,
      location: '',
      address: '',
      state: '',
      city: '',
      cep: ''
    });
  };

  const goToConstructionRegistration = () => {
    if (selectedContract) {
      if (
        selectedContract.soldTo.code !==
          contractAndConstructionsContractsManager.selectedCustomerId ||
        contractAndConstructionsContractsManager.error
      ) {
        const customerType = userState.searchCustomerType;
        const customerId =
          customerType === ECustomerTypeView.EMITTER
            ? selectedContract.soldTo.code
            : selectedContract.shipTo.code;

        dispatch(loadCustomerContracts(customerId, customerType));
      }

      dispatch(
        updateConstructionRegistrationSettings({
          ...INITIAL_CONSTRUCTION_REGISTRATION,
          contractNumber: selectedContract.contractNumber
        })
      );

      history.push(
        `${ERoutes.CONTRACTS_AND_CONSTRUCTIONS}${EConstructionsRoutes.CONSTRUCTION_REGISTRATION}`
      );
    }
  };

  const [showLoadingOrderModal, setShowLoadingOrderModal] = useState(false);
  const [loadFabricationOrderState, setLoadFabricationOrderState] = useState<{
    loading: boolean;
    error: boolean;
    orderId?: number;
    orderNumber?: string;
  }>({ loading: false, error: false });

  const [
    showChooseBetweenNewOrReviewModal,
    setShowChooseBetweenNewOrReviewModal
  ] = useState<ILastOrderDetails>();

  const onBuyAgainClick = (order: ILastOrderDetails) => {
    setShowChooseBetweenNewOrReviewModal(order);
  };

  const closeChooseBetweenNewOrReviewModal = () => {
    setShowChooseBetweenNewOrReviewModal(undefined);
  };

  const commitBuyAgain = async (orderId: number) => {
    const orderNumber =
      selectedContract?.lastOrderDetails?.find((lod) => lod.id === orderId)
        ?.orderNumber || '';

    const loadFabricationOrderFromId = async (): Promise<IFabricationOrder> => {
      const fabricationOrdersService = new FabricationOrdersService();
      return fabricationOrdersService.getFabricationOrderFromId(orderId);
    };

    try {
      setLoadFabricationOrderState({
        loading: true,
        error: false,
        orderId,
        orderNumber
      });
      setShowLoadingOrderModal(true);
      const fabricationOrder = await loadFabricationOrderFromId();
      const fabricationPurchaseState =
        getFabricationPurchaseStateFromFabricationOrder(fabricationOrder);
      dispatch(
        updateFabricationPurchaseOrderSettings({
          ...fabricationPurchaseState,
          constructionIdentification: {
            ...fabricationPurchaseState.constructionIdentification,
            orderNumber: ''
          }
        })
      );
      setLoadFabricationOrderState({
        loading: false,
        error: false,
        orderId,
        orderNumber
      });
    } catch (error) {
      setLoadFabricationOrderState({
        loading: false,
        error: true,
        orderId,
        orderNumber
      });
    }
  };

  const getCustomerOrderText = (): string | undefined => {
    if (
      !isManagercontractNumber ||
      isManagercontractNumber.length < 6 ||
      !contractsState.contracts ||
      contractsState.contracts.length === 0
    ) {
      return undefined;
    } else {
      const contract = contractsState.contracts?.find(
        (cont) => cont.contractNumber === isManagercontractNumber
      );
      return (
        contract &&
        (`${contract.contractNumber} - ${textEllipsis(
          contract.customerOrder,
          24
        )}` ||
          undefined)
      );
    }
  };

  const canShowTowersSelect = (): boolean => {
    return (
      !!selectedContract &&
      selectedContract.logistic?.towerOption !== null &&
      selectedContract.logistic?.towerOption !== ETowerOption.UNIQUE &&
      !!selectedContract.logistic?.towers &&
      selectedContract.logistic?.towers.length > 0
    );
  };

  const orderNumberAlreadyExistsForSelectedContract =
    selectedContract?.allOrderNumbers?.some(
      (oldOrder) =>
        oldOrder.toUpperCase() ===
        constructionIdentificationState.orderNumber.toUpperCase()
    ) || false;

  const onChangeOrderNumber = (value: string) => {
    const regex = /[^a-zA-Z0-9--]+$/;
    const formattedValue = value.toUpperCase().replace(regex, '');
    // const formattedValue = value.replace(regex, '');
    handleUpdateStateField('orderNumber', formattedValue.trim());
  };

  const showChooseWorkContract = () => {
    return (
      <MessageChooseContract>
        <Message>
          Escolha o contrato de obra <br /> para iniciar seu novo pedido.
        </Message>
      </MessageChooseContract>
    );
  };

  return (
    <>
      {!contractsState.loading && isAnewContractSelected() && (
        <ContractWithoutConstructions
          cleanConstructionIdentificationState={
            cleanConstructionIdentificationState
          }
          goToConstructionRegistration={goToConstructionRegistration}
        />
      )}

      <FabricationContainer isFacelift={true}>
        <ConstructionContainer>
          <Title level={2}>Identificação da obra</Title>

          <span className="subtitle">
            Selecione um contrato para abrir as informações da sua obra.
          </span>

          <ConstructionIdentificationContentBlock className="last-order">
            {userState.isManager && (
              <ContructionIdentificationInputContainer className="facelift">
                <IsManagerFabricationContractInput
                  title="Contrato"
                  loading={contractsState.loading}
                  contractError={contractsState.contractError || false}
                  contractNumber={isManagercontractNumber || ''}
                  setContractNumber={setIsManagerContractNumber}
                  customerOrder={getCustomerOrderText()}
                />
              </ContructionIdentificationInputContainer>
            )}

            {!userState.isManager && (
              <ContructionIdentificationInputContainer className="facelift">
                <FabricationContractsSelect
                  contractNumber={selectedContract?.contractNumber}
                  onChange={(value: string) =>
                    handleChangeContractNumber(value)
                  }
                  contracts={
                    (contractsState.contracts &&
                      contractsState.contracts.filter(
                        (contract) =>
                          contract.status ===
                            EFabricationContractsStatus.OPEN ||
                          contract.status ===
                            EFabricationContractsStatus.NEW_CONTRACT
                      )) ||
                    []
                  }
                  loading={contractsState.loading}
                />
              </ContructionIdentificationInputContainer>
            )}

            <ContructionIdentificationInputContainer className="last-order-facelift">
              <OrderContainer>
                <TextField
                  name="lastOrderNumberInput"
                  label="Código do último pedido"
                  value={selectedContract?.lastOrderNumber || ' - '}
                  disabled={contractsState.loading}
                  readOnly
                ></TextField>
              </OrderContainer>
            </ContructionIdentificationInputContainer>

            <ButtonActionContainer>
              <Button
                name="lastOrdersButton"
                variant="secondary"
                disabled={
                  loadFabricationOrderState.loading ||
                  !selectedContract?.lastOrderNumber ||
                  !selectedContract?.lastOrderDetails
                }
                onClick={() => {
                  dispatch(
                    sendTagging({
                      screenName,
                      itemName: 'button:recomprar_ultimo_pedido',
                      event: 'click',
                      filterInfo: `#cttObra:${selectedContract?.contractNumber}`,
                      contratoObra: selectedContract?.contractNumber,
                      itemDescription: `${itemDescription}_recomprarUltimoPedido`
                    })
                  );

                  selectedContract &&
                    selectedContract.lastOrderDetails &&
                    onBuyAgainClick(selectedContract.lastOrderDetails[0]);
                }}
              >
                Recomprar último pedido
              </Button>

              <Button
                name="lastOrdersButton"
                variant="secondary"
                disabled={
                  loadFabricationOrderState.loading ||
                  !selectedContract?.lastOrderNumber ||
                  !selectedContract?.lastOrderDetails
                }
                onClick={() => {
                  dispatch(
                    sendTagging({
                      screenName,
                      itemName: 'button:ver_ultimos_pedidos',
                      event: 'click',
                      filterInfo: `#cttObra:${selectedContract?.contractNumber}`,
                      contratoObra: selectedContract?.contractNumber,
                      itemDescription: `${itemDescription}_verUltimosPedidos`
                    })
                  );

                  goToFabricationRoute(
                    EFabricationRoutes.FABRICATION_REVIEW_ORDER
                  );
                }}
              >
                Exibir últimos pedidos
              </Button>
            </ButtonActionContainer>

            {showLoadingOrderModal && loadFabricationOrderState.orderNumber && (
              <LoadingFabricationOrderModal
                loading={loadFabricationOrderState.loading}
                error={loadFabricationOrderState.error}
                orderNumber={loadFabricationOrderState.orderNumber}
                onClose={() => setShowLoadingOrderModal(false)}
              />
            )}
          </ConstructionIdentificationContentBlock>

          {userState.isManager && (
            <SearchContractButtonContainer>
              <Button
                variant="primary"
                name="searchContractButton"
                onClick={handleLoadContractByContractNumber}
                loading={contractsState.loading}
                disabled={
                  contractsState.loading ||
                  !isManagercontractNumber ||
                  isManagercontractNumber.length < 4
                }
              >
                Buscar
              </Button>
            </SearchContractButtonContainer>
          )}

          {constructionIdentificationState.contractNumber !== undefined &&
            hasErrorOnLoadSelectedContractDetails() && (
              <FabricationErrorBlock>
                <span>
                  Falha ao carregar os detalhes do contrato{' '}
                  {constructionIdentificationState.contractNumber}.
                </span>
                <ButtonAntd
                  type="primary"
                  onClick={() =>
                    constructionIdentificationState.contractNumber &&
                    handleLoadContractDetails(
                      constructionIdentificationState.contractNumber
                    )
                  }
                >
                  Tentar novamente
                </ButtonAntd>
              </FabricationErrorBlock>
            )}
        </ConstructionContainer>

        {selectedContract ? (
          <>
            <ConstructionContainer>
              <Title level={2}>Identificação do pedido</Title>
              <ConstructionIdentificationContentBlock>
                <ContructionIdentificationInputContainer
                  className={
                    orderNumberAlreadyExistsForSelectedContract
                      ? 'has-error'
                      : undefined
                  }
                >
                  <TextField
                    data-testid="order-number-test-id"
                    label="Número do pedido"
                    name="input-codigo-pedido"
                    value={
                      newOrderContract?.newOrderVersion?.formattedOrderCode
                    }
                    key={constructionIdentificationState?.contractNumber ?? ''}
                    readOnly
                  />
                </ContructionIdentificationInputContainer>
                <ContructionIdentificationInputContainer
                  className={
                    orderNumberAlreadyExistsForSelectedContract
                      ? 'has-error'
                      : undefined
                  }
                >
                  <TextField
                    data-testid="order-number-test-id"
                    label="Identificação do pedido"
                    name="input-codigo-pedido"
                    placeholder="Crie um código para o pedido"
                    value={constructionIdentificationState.orderNumber}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      onChangeOrderNumber(e.target.value);
                    }}
                    supportMessage={
                      !showLoadingOrderModal &&
                      orderNumberAlreadyExistsForSelectedContract
                        ? 'Já existe um pedido com o código digitado.'
                        : constructionIdentificationState.orderNumber &&
                          constructionIdentificationState.orderNumber.trim()
                            .length < 3
                        ? 'Deve ter no mínimo 3 caracteres'
                        : constructionIdentificationState.orderNumber &&
                          constructionIdentificationState.orderNumber.trim()
                            .length > 20
                        ? 'Use de 3 a 20 letras e/ou números'
                        : ''
                    }
                    variant={
                      !showLoadingOrderModal &&
                      orderNumberAlreadyExistsForSelectedContract
                        ? 'danger'
                        : undefined ||
                          (constructionIdentificationState.orderNumber &&
                            constructionIdentificationState.orderNumber.trim()
                              .length < 3)
                        ? 'danger'
                        : undefined
                    }
                    maxLength={24}
                    helperText={msgHelperText}
                    required
                  />
                </ContructionIdentificationInputContainer>

                <ContructionIdentificationInputContainer>
                  <DateField
                    name="dateField"
                    label="Data desejada*"
                    helperText="A estimativa de entrega do pedido está sujeita a alterações."
                    selected={
                      constructionIdentificationState.desiredDate
                        ? moment(
                            constructionIdentificationState.desiredDate,
                            'YYYY-MM-DD'
                          ).toDate()
                        : undefined
                    }
                    data-testid="dateFieldIdentificacaoPedido"
                    onChange={(value: DateType) => {
                      if (value) {
                        handleUpdateStateField('desiredDate', value);
                      }
                    }}
                    minDate={moment().add(1, 'day').toDate()}
                  />
                </ContructionIdentificationInputContainer>
              </ConstructionIdentificationContentBlock>
            </ConstructionContainer>

            <ConstructionContainer>
              <Title level={2}>Endereço da obra</Title>

              <div className="wrapperWorkDetails">
                <div className="workDetails">
                  <ConstructionIdentificationContentBlock>
                    <ContructionIdentificationInputContainer>
                      {contractsState.loading ? (
                        <Skeleton type="input" />
                      ) : (
                        <TextField
                          label={'CEP da obra'}
                          name={'cep'}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const cep = cepInputValidator(e);
                            handleUpdateStateField('cep', cep);
                          }}
                          value={constructionIdentificationState.cep}
                          readOnly
                        />
                      )}
                    </ContructionIdentificationInputContainer>
                  </ConstructionIdentificationContentBlock>

                  <ConstructionIdentificationContentBlock>
                    <ContructionIdentificationInputContainer className="double-width">
                      {contractsState.loading ? (
                        <Skeleton type="input" />
                      ) : (
                        <TextField
                          value={uppercaseOnlyFirstLetter(
                            constructionIdentificationState.address
                          )}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleUpdateStateField('address', e.target.value)
                          }
                          readOnly
                          label={'Logradouro'}
                          name={'logradouro'}
                        />
                      )}
                    </ContructionIdentificationInputContainer>
                  </ConstructionIdentificationContentBlock>
                </div>

                <div className="workDetails">
                  <ConstructionIdentificationContentBlock>
                    <ContructionIdentificationInputContainer>
                      {canShowTowersSelect() ? (
                        <Select
                          value={constructionIdentificationState.towers}
                          onSelect={(value) =>
                            handleUpdateStateField('towers', value as string[])
                          }
                          disabled={!selectedContract}
                          options={
                            selectedContract?.logistic?.towers.map((tower) => {
                              return {
                                label: tower,
                                value: tower
                              };
                            }) as TSelectOptionProps[]
                          }
                          isMultipleSelect={true}
                          label={'Selecione a torre'}
                          name={'towers'}
                          helperText={
                            'Torre ou bloco se refere ao setor do edifício para o qual o contrato se refere.'
                          }
                          supportMessage="Use até 24 letras e/ou números"
                        ></Select>
                      ) : (
                        <TextField
                          value={
                            constructionIdentificationState.towers &&
                            constructionIdentificationState.towers.length > 0
                              ? constructionIdentificationState.towers[0]
                              : ''
                          }
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const regex = /[^a-zA-Z0-9@._\- ]/g;
                            const formattedValue = uppercaseOnlyFirstLetter(
                              e.target.value.replace(regex, '')
                            );
                            handleUpdateStateField('towers', [formattedValue]);
                          }}
                          label={'Torre ou bloco'}
                          name={'towerOrBlock'}
                          helperText={
                            'Torre ou bloco se refere ao setor do edifício para o qual o contrato se refere.'
                          }
                          supportMessage="Use até 24 letras e/ou números"
                        />
                      )}
                    </ContructionIdentificationInputContainer>
                  </ConstructionIdentificationContentBlock>

                  <ConstructionIdentificationContentBlock>
                    <ContructionIdentificationInputContainer columns={2}>
                      {contractsState.loading ? (
                        <Skeleton type="input" />
                      ) : (
                        <Select
                          value={constructionIdentificationState.state}
                          onSelect={(value) =>
                            handleUpdateStateField('state', value as string)
                          }
                          readOnly
                          label={'UF'}
                          name={'UF'}
                          options={[
                            {
                              label: constructionIdentificationState.state,
                              value: constructionIdentificationState.state
                            }
                          ]}
                        ></Select>
                      )}
                    </ContructionIdentificationInputContainer>

                    <ContructionIdentificationInputContainer full>
                      {contractsState.loading ? (
                        <Skeleton type="input" />
                      ) : (
                        <Select
                          value={uppercaseOnlyFirstLetter(
                            constructionIdentificationState.city
                          )}
                          onSelect={(value) =>
                            handleUpdateStateField('city', value as string)
                          }
                          readOnly
                          label={'Cidade'}
                          name={'city'}
                          options={[
                            {
                              label: uppercaseOnlyFirstLetter(
                                constructionIdentificationState.city
                              ),
                              value: uppercaseOnlyFirstLetter(
                                constructionIdentificationState.city
                              )
                            }
                          ]}
                        ></Select>
                      )}
                    </ContructionIdentificationInputContainer>
                  </ConstructionIdentificationContentBlock>
                </div>
              </div>
            </ConstructionContainer>

            <ConstructionContainer>
              <DeliveryNotesContainer>
                <Title level={2}>Observações de entrega</Title>

                <TextArea
                  name="deliveryNotesTextArea"
                  label="Observações"
                  value={constructionIdentificationState.observation}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                    handleUpdateStateField('observation', e.target.value)
                  }
                  cols={200}
                  resizable={false}
                  maxLength={500}
                  supportMessage={
                    constructionIdentificationState.observation.length == 500
                      ? 'Deve ter no máximo 500 caracteres'
                      : 'Use até 500 letras e/ou números'
                  }
                />
              </DeliveryNotesContainer>
            </ConstructionContainer>
          </>
        ) : (
          showChooseWorkContract()
        )}
        {showChooseBetweenNewOrReviewModal && (
          <ChooseBetweenNewOrReviewOrderModal
            onCloseModal={closeChooseBetweenNewOrReviewModal}
            order={showChooseBetweenNewOrReviewModal}
            onChooseCreate={() =>
              commitBuyAgain(showChooseBetweenNewOrReviewModal?.id)
            }
            from={'ConstructionIdentification'}
          />
        )}

        <LoadingModal
          enabled={contractsState.loading}
          title="Aguarde alguns instantes"
          message="Carregando os dados..."
        />

        <ConstructionContainer buttonContainer>
          <ButtonContainer>
            {isOnline ? (
              <Button
                type="button"
                variant="secondary"
                labelPosition="center"
                name="cancelAndReturnButton"
                onClick={onClickCancelButton}
                ariaLabel="Voltar"
              >
                Voltar
              </Button>
            ) : (
              <Tooltip
                title={'Verifique sua conexão à internet'}
                trigger={'hover'}
                open={isOfflineTooltipOpen2}
              >
                <span
                  onMouseEnter={() => setIsOfflineTooltipOpen2(true)}
                  onMouseLeave={() => setIsOfflineTooltipOpen2(false)}
                  style={{
                    minWidth: '16.875rem'
                  }}
                >
                  <Button
                    type="button"
                    variant="secondary"
                    labelPosition="center"
                    name="cancelAndReturnButton"
                    onClick={onClickCancelButton}
                    ariaLabel="Voltar"
                    disabled={true}
                    fullWidth={true}
                  >
                    Voltar
                  </Button>
                </span>
              </Tooltip>
            )}
            {isOnline ? (
              <Button
                name="goToDetailButton"
                onClick={onNextStepClick}
                variant="primary"
                disabled={!canShowToNextStep() || !isOnline}
              >
                Avançar para o detalhamento
              </Button>
            ) : (
              <Tooltip
                title={'Verifique sua conexão à internet'}
                trigger={'hover'}
                open={isOfflineTooltipOpen}
              >
                <span
                  onMouseEnter={() => setIsOfflineTooltipOpen(true)}
                  onMouseLeave={() => setIsOfflineTooltipOpen(false)}
                >
                  <Button
                    name="goToDetailButton"
                    onClick={onNextStepClick}
                    variant="primary"
                    disabled={!canShowToNextStep() || !isOnline}
                  >
                    Avançar para o detalhamento
                  </Button>
                </span>
              </Tooltip>
            )}
          </ButtonContainer>
        </ConstructionContainer>
      </FabricationContainer>
    </>
  );
};

export default ConstructionIdentification;
